var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.11427C2 3.81875 2.11346 3.53533 2.31542 3.32636C2.51739 3.1174 2.79131 3 3.07692 3H28.9231C29.2087 3 29.4826 3.1174 29.6846 3.32636C29.8865 3.53533 30 3.81875 30 4.11427C30 4.40979 29.8865 4.69321 29.6846 4.90218C29.4826 5.11114 29.2087 5.22854 28.9231 5.22854H27.2718V18.6414C27.2718 19.6412 26.8827 20.598 26.1949 21.3008C25.5063 22.0039 24.5777 22.3979 23.6103 22.3972H18.6234L23.2183 27.092C23.319 27.1948 23.3991 27.3171 23.4541 27.452C23.5091 27.5869 23.5379 27.7316 23.5388 27.878C23.5397 28.0244 23.5128 28.1695 23.4595 28.3051C23.4062 28.4407 23.3277 28.5641 23.2283 28.6683C23.1289 28.7725 23.0107 28.8554 22.8804 28.9123C22.75 28.9692 22.6101 28.999 22.4686 29C22.3272 29.0009 22.1869 28.9731 22.0559 28.9179C21.9248 28.8628 21.8055 28.7815 21.7048 28.6787L16 22.8489L10.2952 28.6787C10.0918 28.8864 9.81706 29.0019 9.53135 29C9.24565 28.998 8.97239 28.8787 8.77169 28.6683C8.571 28.4579 8.45931 28.1736 8.46119 27.878C8.46308 27.5824 8.57838 27.2996 8.78174 27.092L13.3766 22.3972H8.38974C7.42338 22.3972 6.49436 22.0035 5.80513 21.3008C5.46465 20.9531 5.19416 20.5391 5.00931 20.0826C4.82446 19.6262 4.72892 19.1363 4.72821 18.6414V5.22854H3.07692C2.79131 5.22854 2.51739 5.11114 2.31542 4.90218C2.11346 4.69321 2 4.40979 2 4.11427Z",
    fill: "url(#paint0_linear_4684_37179)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4684_37179",
    x1: 1.98322,
    y1: 26.3631,
    x2: 36.3334,
    y2: 12.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95C843"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.931be3271f12f6519e4128c0e5bab136.svg";
export { ForwardRef as ReactComponent };